import React from 'react';
import PropTypes from 'prop-types';
import { LinkHasProtocolRegex } from '../../../../../constants/Regex';

// Modified by AI on 05/26/2026. Edit #1.
const LinkTag = ({ url = '', label = '' }) => {
    const handleLinkClick = () => {
        const linkUrl = !url.match(LinkHasProtocolRegex) ? `https://${url}` : url;
        window.open(linkUrl, '_blank');
    };

    return (
        <a href={url}
            onClick={handleLinkClick}
            style={{ cursor: 'pointer' }}
            target={'_blank'}
            rel="noreferrer"
        >
            {label}
        </a>
    );
};

LinkTag.propTypes = {
    url: PropTypes.string,
    label: PropTypes.string,
};

export default LinkTag;
